import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var GiftSVG = function GiftSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M4 27a3 3 0 003 3h8V19H4zM17 30h8a3 3 0 003-3v-8H17zM29 8h-4.56A3.91 3.91 0 0025 6a4 4 0 00-7-2.66 16.85 16.85 0 00-2 2.79 16.85 16.85 0 00-2-2.79A4 4 0 007 6a3.91 3.91 0 00.56 2H3a1 1 0 00-1 1v7a1 1 0 001 1h12V8h2v9h12a1 1 0 001-1V9a1 1 0 00-1-1zM11 8a2 2 0 111.49-3.34A13.16 13.16 0 0114.71 8zm8.51-3.34A2 2 0 1121 8h-3.71a13.16 13.16 0 012.22-3.34z"
  }));
};
GiftSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(GiftSVG);